import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledNewTag = styled.div`
  border-radius: 12px;
  padding: 1px 6px;
  font-size: 9px;
  font-weight: 500;
  line-height: 13px;
  text-align: center;
  color: #ffffff;
  background: ${({ theme }) => theme.colors.textNegative};
`

interface NewTagProps {
  style?: React.CSSProperties
}

const NewTag: React.FC<NewTagProps> = ({ style }) => {
  const { t } = useTranslation()

  return <StyledNewTag style={style}>{t('new')}</StyledNewTag>
}

export default NewTag
